module.exports = __webpack_public_path__ + "static/media/notification.9c791c71.svg";